import { makeAutoObservable } from "mobx";
import { ReactNode } from "react";
import { noPropagateDialog$ } from "./ApiEvents";

export type IconType = 'error' | 'success' | 'warning'

interface INotifier {
  title: string | ReactNode;
  subtitle?: string;
  iconType?: IconType
  content: string | string[];
  onClose: Function;
  timeOut: number;
  onSubmit?: () => void;
  onFinishTimeout?: () => void
}

class NotifierStore {
  private interval: any;
  private counter: number;
  private percent: number;
  private open: boolean;
  private showProgress: boolean;
  private notifier: INotifier;
  constructor() {
    this.notifier = {
      title: "",
      subtitle: "",
      iconType: undefined,
      content: "",
      timeOut: 6000,
      onClose: () => {},
      onSubmit: undefined,
      onFinishTimeout: () => {}
    };
    this.open = false;
    this.showProgress = false;
    this.interval = 0;
    this.counter = 0;
    this.percent = 0;
    makeAutoObservable(this);
  }

  public setNotifier(notifier: INotifier): void {
    if (noPropagateDialog$.getValue()) return;
    this.notifier = notifier;
  }

  public getnotifier(): INotifier {
    return this.notifier;
  }

  public setOpen(open: boolean): void {
    if (open && noPropagateDialog$.getValue()) return;
    this.open = open;
    this.startTimeOut();
  }

  public getOpen(): boolean {
    return this.open;
  }

  public getTitle(): string | ReactNode {
    return this.notifier.title;
  }

  public getContent(): string | string[] {
    return this.notifier.content;
  }

  public getOnClose() {
    return this.notifier.onClose();
  }

  public getOnSubmit() {
    if (this.notifier?.onSubmit) {
      this.notifier.onSubmit();
      return true
    }
    return false
  }

  public haveOnsubmit() {
    return this.notifier.onSubmit
  }

  public getPercent(): number {
    return this.percent;
  }

  get subtitle(): string {
    return this.notifier.subtitle || ''
  }

  get iconType(): IconType | undefined {
    return this.notifier.iconType || undefined
  }

  setPercent(percent: number): void {
    this.percent = percent;
  }

  private startTimeOut() {
    clearInterval(this.interval);
    this.interval = 0;
    this.counter = 0;
    this.percent = 0;
    this.showProgress = true;
    this.interval = this.notifier.timeOut && this.open ? setInterval(() => {
      this.counter++;
      this.setPercent((this.counter * 100) / (this.notifier.timeOut / 200 - 1));
      if (this.counter >= this.notifier.timeOut / 200) {
        this.setOpen(false);
        this.stopTimer();
        if (!!this.notifier.onFinishTimeout) {
          this.notifier.onFinishTimeout();
        }
      }
    }, 200) : 0
  }

  private stopTimer() {
    clearInterval(this.interval);
  }

  public onMouseEnter(): void {
    this.showProgress = false;
    this.setPercent(100);
    this.stopTimer();
  }

  public getShowProgress() {
    return this.showProgress;
  }
}

const notifierStore = new NotifierStore();
export { notifierStore };
